import { benPlayerClient } from "../http-client";
import { PlayerBonusDto, PlayerObtainableBonusDto, PlayerWalletDto } from "../models/ben-player-models";

export namespace BenPlayerApi {
    export async function fetchPlayerWallet(clientId: string): Promise<PlayerWalletDto> {
        // ClentId will be added to the request header automatically
        if (!clientId) return;

        const response = await benPlayerClient.get<PlayerWalletDto>("/wallet");

        return response.data;
    }

    export async function fetchPlayerBonuses(clientId: string): Promise<PlayerBonusDto[]> {
        // ClentId will be added to the request header automatically
        if (!clientId) return;

        const response = await benPlayerClient.get<PlayerBonusDto[]>("/bonuses");

        return response.data;
    }

    export async function getObtainableBonusBanner(clientId: string): Promise<PlayerObtainableBonusDto> {
        // ClentId will be added to the request header automatically
        if (!clientId) return;

        const response = await benPlayerClient.get<PlayerObtainableBonusDto>("/obtainable-bonus");

        return response.data;
    }
}
